export enum JobQualificationsMatchTypeEnum {
    UnitRequirements,
    JobTrack,
    UnitTrack,
    JobRequirements
}
